import axios from 'axios';

// Handle HTTP request
export function handleRequest(type, url, data={}, customHeaders={}) {
  return new Promise((resolve, reject) => {
    axios({
      method: type,
      url: url, // required
      data: data,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        ...customHeaders
      }
    })
      .then(function (response) {
        let responseData = response.data;
        resolve(responseData);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}